<template>
  <app-layout
          :isVerticalMenuActive = "store.state[storeModuleName].isVerticalMenuActive"
          :isVerticalMenuCollapsed = "store.state[storeModuleName].isVerticalMenuCollapsed"
          @is-vertical-menu-collapsed="(value)=> store.commit(`${storeModuleName}/SET_IS_VERTICAL_MENU_COLLAPSED`, value) "
  >
      <template #verticalMenu v-if="store.state[storeModuleName].isVerticalMenuActive">
          <element-list-filter>
            <template #filterDataForm>
              <slot name="filterDataForm" :isVerticalMenuCollapsed="store.state[storeModuleName].isVerticalMenuCollapsed"></slot>
            </template>
          </element-list-filter>
      </template>
      <template #content>
          <elements-list
                  :extra-table-columns='tableColumns'
                  :fetch-data-url='fetchDataUrl'
                  :delete-data-url='deleteDataUrl'
                  :extra-filters="extraFilters"
                  :store-module-name="storeModuleName"

                  :tableRepresentation="tableRepresentation"
                  :gridRepresentation="gridRepresentation"

                  :addDataSidebarAvailable="addDataSidebarAvailable"

                  :useDefaultActions="useDefaultActions"

                  :idKey="idKey"
                  :extraViews="extraViews"

                  :searchFieldActive="searchFieldActive"
          >
              <template #tableCellCustomRepresentations="cell">
                  <slot name="tableCellCustomRepresentations" v-bind="cell"></slot>
              </template>

              <template #gridRepresentationCard="object">
                  <slot name="gridRepresentationCard" v-bind="object"></slot>
              </template>

              <template #extraRepresentations="object">
                  <slot name="extraRepresentations" v-bind="object"></slot>
              </template>

              <template #extraActionsCard="object">
                  <slot name="extraActionsCard" v-bind="object"></slot>
              </template>

          </elements-list>
          <element-list-add-new
                  v-if="store.state[storeModuleName].isAddNewElementSidebarActive"
                  :store-module-name="storeModuleName"
          >
              <template #addDataForm>
                  <slot name="addDataForm"></slot>
              </template>
          </element-list-add-new>
    </template>

  </app-layout>
</template>

<script>

import store from '@/store'
import { onBeforeMount, onBeforeUnmount, } from '@vue/composition-api'


import AppLayout from '@core/components/app-layout/AppLayout.vue'
import useAppLayout from '@core/components/app-layout/useAppLayout'

import ElementsList from "./appElementList/AppElementsList.vue";
import ElementListFilter from "./appElementListFilter/AppElementListFilter";

import ElementListAddNew from "./appElementListAddNew/AppElementListAddNew";
import useElementListAddNew from "./appElementListAddNew/useAppElementListAddNew";

import appElementsStoreModule from './appElementsStoreModule'


export default {
  components: {
    AppLayout,

    ElementListFilter,
    ElementsList,
    ElementListAddNew
  },

  props: {

    // store props
    storeModuleName: {
      type: String,
      default: "",
      required: true
    },
    storeModuleConfig: {
      type: Object,
      default: ()=>{
        return {}
      },
      required: true
    },


    // other props
    tableColumns: {
      type: Array,
      default: () => {
        return []
      },
      required: true
    },


    // urls to manage actions
    fetchDataUrl: {
      type: String,
      default: "",
      required: true
    },
    addDataUrl: {
      type: String,
      default: "",
      required: false
    },
    updateDataUrl: {
      type: String,
      default: "",
      required: false
    },
    deleteDataUrl: {
      type: String,
      default: "",
      required: false
    },

    extraFilters: {
      type:Object,
      default: ()=>{},
      required: false
    },

    // props for layout
    isVerticalMenuActive: {
      type: Boolean,
      default: false,
      required: false
    },

    tableRepresentation: {
      type: Boolean,
      default: true,
      required: false
    },

    gridRepresentation: {
      type: Boolean,
      default: false,
      required: false
    },

    addDataSidebarAvailable: {
      type: Boolean,
      default: false,
      required: false
    },

    useDefaultActions: {
      type: Array,
      default: () => [],
      required: false
    },

    idKey: {
      type: String,
      default: "uuid",
      required: false
    },

    extraViews: {
      type: Array,
      default: () => [],
      required: false
    },

    searchFieldActive: {
      type: Boolean,
      default: true
    },

  },




  setup(props) {


      const {isAddNewElementSidebarActive} = useElementListAddNew();

      const {isVerticalMenuCollapsed} = useAppLayout()

      const storeModule = appElementsStoreModule(props.storeModuleConfig)


      // Re-register module with additional options
      onBeforeMount(() => {
          if (store.hasModule(props.storeModuleName)) {
              store.unregisterModule(props.storeModuleName)
          }
          store.registerModule(props.storeModuleName, storeModule)
      })


      // UnRegister on leave
      onBeforeUnmount(() => {
          if (store.hasModule(props.storeModuleName)) store.unregisterModule(props.storeModuleName)
      })


      return {
          // Sidebar
          isAddNewElementSidebarActive,
          isVerticalMenuCollapsed,
          store,
      }
  },

}
</script>


